import { Box } from '@mui/material';
import { PendingVerificationContainer } from 'modules/PendingVerification';
import { useParams } from 'react-router-dom';

type Props = {}

const PendingVerification = (props: Props) => {
    const { userType } = useParams();
    return (

        <PendingVerificationContainer />

    )
}

export default PendingVerification  